import SearchBigIcon from '/public/icons/search-big.svg';

export const NoSearchYetState = () => {
  return (
    <div className="flex flex-col gap-[14px] items-center max-md:text-center">
      <SearchBigIcon viewBox="0 0 80 80" className="max-md:h-15 max-md:w-15" />
      <h3 className="light text-black max-md:!text-xl max-md:!leading-[110%]">
        You haven&apos;t searched for anything yet
      </h3>
    </div>
  );
};
